import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SortUtil } from '@iot-platform/iot-platform-utils';
import { get } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { COMMON_FILTERS_OPTIONS } from '../../filter-engine-v2/settings/filter-engine-v2.settings';
import { FilterCriteriaConfiguration } from '../models';
import { FilterEngineSettingsService } from './filter-engine-settings.service';

@Injectable()
export class FilterEngineService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly filterEngineSettingsService: FilterEngineSettingsService = inject(FilterEngineSettingsService);

  getFilterCriteriaByConcept(masterView: string): Observable<FilterCriteriaConfiguration[]> {
    return this.httpClient.get<FilterCriteriaConfiguration[]>(`assets/engines/filters/filter-criteria-${masterView}.json`).pipe(
      map((data) => {
        const masterViewSettings = get(this.filterEngineSettingsService.options(), masterView);
        return this.sortFilterCriteria(this.mergeAdditionalOptions(masterViewSettings, data));
      })
    );
  }

  sortFilterCriteria(filterCriteria: FilterCriteriaConfiguration[]): FilterCriteriaConfiguration[] {
    filterCriteria.sort(SortUtil.sortByOrder);
    filterCriteria.forEach((criteria: FilterCriteriaConfiguration) =>
      Array.isArray(criteria.options) ? criteria.options.sort(SortUtil.sortByOrder) : criteria
    );
    return filterCriteria;
  }

  private mergeAdditionalOptions(masterViewSettings: any, configurations: FilterCriteriaConfiguration[]): FilterCriteriaConfiguration[] {
    return configurations.reduce((acc: FilterCriteriaConfiguration[], item: FilterCriteriaConfiguration) => {
      item.options = item.options.map((option: any) => {
        const commonConfig = get(COMMON_FILTERS_OPTIONS, option.key);
        let options = { ...option.options };
        if (commonConfig) {
          options = { ...options, ...commonConfig };
        }
        const filter = get(masterViewSettings, [item.key, option.key]);
        if (filter) {
          options = { ...options, ...filter };
        }
        return { ...option, options };
      });
      return [...acc, item];
    }, []);
  }
}
